<template>
  <div class="app-main">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.app-main {
  height: 100%;
}
</style>
